/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Waiting_Room_TitleInputs */



/**
* | output |
* | --- |
* | "Wundo is in the waiting room" |
*
* @param {Meeting_Notetaker_Issue_Waiting_Room_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_waiting_room_title = /** @type {((inputs?: Meeting_Notetaker_Issue_Waiting_Room_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Waiting_Room_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo staat in de wachtruimte")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo est dans la salle d'attente")
	return /** @type {LocalizedString} */ ("Wundo is in the waiting room")
});